import { NgModule } from '@angular/core';
import { MaterialModule } from './modules/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { DropdownTriggerForDirective } from './components/chip-autocomplete/dropdown-panel/dropdown-trigger-for.directive';

import { DropdownPanelComponent } from './components/chip-autocomplete/dropdown-panel/dropdown-panel.component';
import { InstitutionAutocompleteComponent } from './components/institution-autocomplete/institution-autocomplete.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { InstitutionCardComponent } from './components/institution-card/institution-card.component';
import { ChipAutocompleteComponent } from './components/chip-autocomplete/chip-autocomplete.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [
    ChipAutocompleteComponent,
    InstitutionAutocompleteComponent,
    SpinnerComponent,
    InstitutionCardComponent
  ],
  declarations: [
    ChipAutocompleteComponent,
    DropdownPanelComponent,
    DropdownTriggerForDirective,
    InstitutionAutocompleteComponent,
    SpinnerComponent,
    InstitutionCardComponent
  ]
})
export class SharedModule {}
